import React from 'react'
import styled from 'styled-components'

export default function CalendarBadge ({ month, number }) {

  return (
    <Container>
      <MonthContainer>
        <Month>{month.toUpperCase()}</Month>
      </MonthContainer>

      <NumberContainer>
        <Number color="#19A0FA">{number}</Number>
      </NumberContainer>
    </Container>
  )
}

const Container = styled.div`
  
`

const MonthContainer = styled.div`
  padding: 1px;
  border: 1.5px #C6D7EC solid;
  width: 41px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`

const Month = styled.p`
  font-size: 10px;
  text-align: center;
`

const NumberContainer = styled.div`
  padding: 1px 0;
  border: 1.5px #C6D7EC solid;
  width: 41px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-width: 0;
`

const Number = styled.p`
  text-align: center;
  font-weight: 600;
  color: ${props => props.color};
`
